import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  wrapper: {
    marginRight: -48,
    [theme.breakpoints.down('xs')]: {
      marginTop: -4,
    },
  },
  illustration: {
    margin: '0 -24px',
  },
  content: {
    margin: '24px 0',
    display: 'grid',
    gap: 8,
  },
  title: {
    margin: 0,
    fontWeight: 'bold',
    letterSpacing: '0.15px',
    lineHeight: '23px',
  },
  description: {
    margin: 0,
  },
}));
